import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Account } from '@shared/models';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'gcc-mobile-user-info',
  templateUrl: './mobile-user-info.component.html',
  styleUrls: ['./mobile-user-info.component.scss']
})
export class MobileUserInfoComponent {
  @Input() public user: Account;
  @Output() public logout: EventEmitter<void> = new EventEmitter();

  public mailtoLink: string;
  private mailAddress = 'GCCFeedback@deloitte.com';
  private mailSubject: string;

  constructor(private translate: TranslateService) {
    this.translate.get('header.user_info.mail_subject').subscribe(value => {
      this.mailSubject = value;
      this.mailtoLink = `mailto:${this.mailAddress}?Subject=${this.mailSubject}`;
    });
  }

  public onLogout() {
    this.logout.emit();
  }
}
